/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router-dom components
import {Link} from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import IllustrationLayout from "../../components/IllustrationLayout";
import {useMeQuery} from "../../../../store/api/auth";
import {
    useCreateAccountWithOtpMutation,
    useIsuniqueMutation,
    useSendOtpMutation
} from "../../../../store/api/validation";
import {Icon} from "@mui/material";
import OtpInput from "react-otp-input";
import MuiPhoneNumber from "material-ui-phone-number";
import Grid from "@mui/material/Grid";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import {Form, Formik} from "formik";
import {EmailMobile} from "../components/EmailMobile";
import initialValues from "../schemas/initialValues";
import form from "../schemas/form";
import validations from "../schemas/validations";
import {notificationActions} from "../../../../store/notification/notification-slice";
import {useDispatch} from "react-redux";
import {OtpMobileVerification, OtpVerification} from "../components/OtpMobileVerification";
import {OtpEmailVerification} from "../components/OtpEmailVerification";
import {ReCAPTCHA} from "react-google-recaptcha";
//TODO burada kaldım
// email fieldda onBlur, focus gittiğinde çalışır o vakitte unique mi diye bakılabilir.
function Illustration() {
    const navigate = useNavigate();
    const {data: user, isLoading, isError} = useMeQuery();
    const [sendOtp] = useSendOtpMutation();
    const [createAccoutWithOtp] = useCreateAccountWithOtpMutation();

    const [emailData, setEmailData] = useState("");
    const [mobileData, setMobileData] = useState("");
    const [isEmailSended, setIsEmailSended] = useState(false);
    const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);
    const [isMobileSended, setIsMobileSended] = useState(false);
    const [isMobileConfirmed, setIsMobileConfirmed] = useState(false);


    useEffect(() => {
        if (user) {
            navigate("/");
        }
    }, [user, navigate]);

    function getSteps() {
        return ["Email & Mobile ", "Phone Verification", "Email Verification"];
    }

    const [nextValid, setNextValid] = useState(false);

    function getStepContent(stepIndex, formData) {
        switch (stepIndex) {
            case 0:
                return (
                    <EmailMobile formData={formData} setNextValid={setNextValid}/>
                );
            case 1:
                return (
                    <OtpMobileVerification formData={formData} setNextValid={setNextValid}/>
                );
            case 2:
                return <OtpEmailVerification formData={formData} setNextValid={setNextValid}/>;
            default:
                return null;
        }
    }

    const {formId, formField} = form;

    const [activeStep, setActiveStep] = useState(0);

    const steps = getSteps();
    const isLastStep = activeStep === steps.length - 1;
    const dispatch = useDispatch();
    const nav = useNavigate();


    const handleSubmit = async (values, actions) => {
        //TODO zaten mail gönderildiyse bu durumları kontrol et.
        if (activeStep === 0) {
            setEmailData(values.email);
            setMobileData(values.mobile);

            //OTP istemi yap ve localStorage'a bunu kaydet.
            dispatch(notificationActions.showLoading(true));
            const sms_payload = await sendOtp({
                destination: values.mobile,
                email: values.email
            });

            if (sms_payload?.data?.success) {
                dispatch(notificationActions.showMessage({
                    message: `SMS: ${sms_payload?.data?.message}`,
                    variant: "success"
                }));
                setIsMobileSended(true);
            }
            if (sms_payload?.error?.data) {
                dispatch(notificationActions.showMessage({
                    message: `SMS: ${sms_payload?.error?.data?.detail}`,
                    variant: "error"
                }));
            }


            const email_payload = await sendOtp({
                destination: values.email,
                email: values.email
            });
            if (email_payload?.data?.success) {
                dispatch(notificationActions.showMessage({
                    message: `Email: ${email_payload?.data?.message}`,
                    variant: "success"
                }));
                setIsEmailSended(true);
            }
            if (email_payload?.error?.data) {
                dispatch(notificationActions.showMessage({
                    message: `Email: ${email_payload?.error?.data?.detail}`,
                    variant: "error"
                }));
            }
            dispatch(notificationActions.showLoading(false));
            setActiveStep(activeStep + 1);
        } else if (activeStep === 1) {
            // Mobile verification
            dispatch(notificationActions.showLoading(true));
            const payload = await sendOtp({
                destination: values.mobile,
                email: values.email,
                verify_otp: values.mobile_otp
            });
            if (payload?.data?.OTP) {
                dispatch(notificationActions.showMessage({
                    message: `Mobile: ${payload?.data?.OTP[0]}`,
                    variant: "success"
                }));
                setIsMobileConfirmed(true);
                setActiveStep(activeStep + 1);
            }
            if (payload?.error?.data) {
                dispatch(notificationActions.showMessage({
                    message: `Mobile: ${payload?.error?.data?.detail}`,
                    variant: "error"
                }));
            }
            dispatch(notificationActions.showLoading(false));
        } else if (isLastStep) {
            // email verification
            dispatch(notificationActions.showLoading(true));
            const payload = await createAccoutWithOtp({
                email: values.email,
                phone: values.mobile,
                verify_otp: values.email_otp,
                is_login: true
            });

            if (payload?.data?.token) {
                dispatch(notificationActions.showMessage({
                    message: `Successfully registered/logged in`,
                    variant: "success"
                }));
                await localStorage.clear();
                await localStorage.setItem('token', payload.data.token);
                nav('/');
                setIsEmailConfirmed(true);
            }
            if (payload?.error?.data) {
                dispatch(notificationActions.showMessage({
                    message: `Email: ${payload?.error?.data?.detail}`,
                    variant: "error"
                }));
            }
            dispatch(notificationActions.showLoading(false));
        }

        localStorage.setItem("signUpData", JSON.stringify({
            email: emailData,
            mobile: mobileData,
            isEmailSended,
            isMobileSended,
            isEmailConfirmed,
            isMobileConfirmed
        }));
    };
    const currentValidation = validations[activeStep];


    return (
        <IllustrationLayout
            title="Sign Up"
            description=""
            illustration={bgImage}
        >
            <Formik
                initialValues={initialValues}
                validationSchema={currentValidation}
                onSubmit={handleSubmit}
            >
                {({values, errors, touched, isSubmitting, setFieldValue}) => (
                    <Form id={formId} autoComplete="off">
                        <Card>
                            <MDBox mt={-3} mb={3} mx={2}>
                                <Stepper activeStep={activeStep} alternativeLabel>
                                    {steps.map((label) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </MDBox>
                            <MDBox p={2}>
                                <MDBox>
                                    {getStepContent(activeStep, {
                                        values,
                                        touched,
                                        formField,
                                        errors,
                                        setFieldValue
                                    })}
                                    <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                                        {activeStep === 0 ? (
                                            <MDBox/>
                                        ) : (
                                            <MDButton variant="gradient" color="light" onClick={() => {
                                                setActiveStep(activeStep - 1)
                                            }}>
                                                back
                                            </MDButton>
                                        )}
                                        <MDButton
                                            disabled={!nextValid}
                                            type="submit"
                                            variant="gradient"
                                            color="dark"
                                        >
                                            {isLastStep ? "send" : "next"}
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>

                    </Form>)}
            </Formik>
        </IllustrationLayout>
    );
}

export default Illustration;
